/**
 * Helpers do método Cripto Web3 — 100% simulação visual.
 * Sem Wallet Connect / SDK Web3 real.
 */

export type CryptoCoin = 'eth' | 'usdc';

export const CRYPTO_COIN_LABEL: Record<CryptoCoin, string> = {
  eth: 'ETH',
  usdc: 'USDC',
};

/** Gera endereço fake `0xtt` + 38 hex chars. Determinístico se seed dada. */
export function generateMockWallet(seed?: string): string {
  const hex = '0123456789abcdef';
  let out = '0xtt';
  // Pseudo-RNG xorshift se houver seed; senão Math.random
  let state = 0;
  if (seed) {
    for (let i = 0; i < seed.length; i++) state = (state * 31 + seed.charCodeAt(i)) | 0;
  }
  for (let i = 0; i < 38; i++) {
    if (seed) {
      state ^= state << 13;
      state ^= state >>> 17;
      state ^= state << 5;
      out += hex[Math.abs(state) % 16];
    } else {
      out += hex[Math.floor(Math.random() * 16)];
    }
  }
  return out;
}

/** Curta `0xtt5f3aBc...e2a9` mantendo 6 chars no início e 4 no fim. */
export function shortAddress(address: string, head = 6, tail = 4): string {
  if (address.length <= head + tail + 1) return address;
  return `${address.slice(0, head)}…${address.slice(-tail)}`;
}

/** URI EIP-681 pra ETH (`ethereum:0x...?value=WEI`). */
export function buildEthUri(address: string, amountEth: number): string {
  const wei = BigInt(Math.round(amountEth * 1e18));
  return `ethereum:${address}?value=${wei.toString()}`;
}

/** URI ERC-20 pra USDC mainnet (estética — não validamos chain). */
export function buildUsdcUri(address: string, amountUsdc: number): string {
  const units = BigInt(Math.round(amountUsdc * 1e6)); // USDC = 6 decimais
  return `ethereum:${address}/transfer?address=0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48&uint256=${units.toString()}`;
}

export function formatCryptoValue(coin: CryptoCoin, amount: number): string {
  if (coin === 'eth') {
    return `${amount.toFixed(amount < 0.001 ? 6 : 4)} ETH`;
  }
  return `${amount.toFixed(2)} USDC`;
}
